import {
  PLAYLIST_LOADING,
  PLAYLIST_SET_DATA,
  PLAYLIST_SET_DETAILS,
  PLAYLIST_SET_OWN_DATA,
  PLAYLIST_SET_FOLLOWING_DATA,
  CREATE_SESSION_START,
  CREATE_SESSION_SUCCESS,
  CREATE_SESSION_FAILURE,
  GET_SESSION_START,
  GET_SESSION_SUCCESS,
  GET_SESSION_FAILURE,
  GET_SESSION_BY_USER_START,
  GET_SESSION_BY_USER_SUCCESS,
  GET_SESSION_BY_USER_FAILURE,
  SEARCH_START,
  SEARCH_SUCCESS,
  SEARCH_FAILURE,
  ENROLE_COURSE_START,
  ENROLE_COURSE_SUCCESS,
  ENROLE_COURSE_FAILURE,
  GET_ENROLE_COURSE_START,
  GET_ENROLE_COURSE_SUCCESS,
  GET_ENROLE_COURSE_FAILURE,
} from "./constants";
import {
  _createPlaylist,
  _fetchPlaylist,
  _fetchOwnPlaylist,
  _fetchFollowingPlaylist,
  _createSession,
  _getSession,
  _getSessionByUserId,
  _search,
  _enroleCourse,
  _getEnroledCourse
} from "./services";
import { errorParser } from '../../services/apiErrorParser';

export function playlistSetLoading(loading) {
  return {
    type: PLAYLIST_LOADING,
    payload: loading,
  };
}
export function playlistSetData(data) {
  return {
    type: PLAYLIST_SET_DATA,
    payload: data,
  };
}
export function playlistSetDetails(data) {
  return {
    type: PLAYLIST_SET_DETAILS,
    payload: data,
  };
}
export function playlistSetOwnData(data) {
  return {
    type: PLAYLIST_SET_OWN_DATA,
    payload: data,
  };
}
export function playlistSetFollowingData(data) {
  return {
    type: PLAYLIST_SET_FOLLOWING_DATA,
    payload: data,
  };
}
export const fetchPlaylist = (params) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(playlistSetLoading(true));
    _fetchPlaylist(params)
      .then(async (res) => {
        if (params?.id) {
          dispatch(playlistSetDetails(res));
        } else {
          dispatch(playlistSetData(res));
        }
        resolve(res);
      })
      .catch(async (err) => {
        reject(err);
      });
  });
};

export const createNewPlaylist = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    _createPlaylist(data)
      .then(async (res) => {
        resolve(res);
      })
      .catch(async (err) => {
        reject(err);
      });
  });
};

export const fetchOwnPlaylist = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(playlistSetLoading(true));
    _fetchOwnPlaylist()
      .then(async (res) => {
        dispatch(playlistSetOwnData(res));
        resolve(res);
      })
      .catch(async (err) => {
        reject(err);
      })
      .finally(() => {
        dispatch(playlistSetLoading(false));
      });
  });
};
export const fetchFollowingPlaylist = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(playlistSetLoading(true));
    _fetchFollowingPlaylist()
      .then(async (res) => {
        dispatch(playlistSetFollowingData(res));
        resolve(res);
      })
      .catch(async (err) => {
        reject(err);
      })
      .finally(() => {
        dispatch(playlistSetLoading(false));
      });
  });
};
/**
 * create session
 */
const createSessionStart = data => {
  return {
    type: CREATE_SESSION_START,
    payload: data
  }
}
const createSessionSuccess = data => {
  return {
    type: CREATE_SESSION_SUCCESS,
    payload: data
  }
}
const createSessionFailure = error => {
  return {
    type: CREATE_SESSION_FAILURE,
    payload: error
  }
}
export const createSession = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(createSessionStart(true));
    _createSession(data)
      .then(async (res) => {
        dispatch(createSessionSuccess(res));
        resolve(res);
      })
      .catch(async (err) => {
        const parsedError = errorParser.parseError(err)
        dispatch(createSessionFailure(parsedError));
        reject(err);
      });
  });
};
/**
 * Get session List
 */
 const getSessionStart = data => {
  return {
    type: GET_SESSION_START,
    payload: data
  }
}
const getSessionSuccess = data => {
  return {
    type: GET_SESSION_SUCCESS,
    payload: data
  }
}
const getSessionFailure = error => {
  return {
    type: GET_SESSION_FAILURE,
    payload: error
  }
}
export const getSession = (id) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(getSessionStart(true));
    _getSession(id)
      .then(async (res) => {
        dispatch(getSessionSuccess(res));
        resolve(res);
      })
      .catch(async (err) => {
        const parsedError = errorParser.parseError(err)
        dispatch(getSessionFailure(parsedError));
        reject(err);
      });
  });
};
/**
 * Get session list by userid
 */
 const getSessionByUserIdStart = data => {
  return {
    type: GET_SESSION_BY_USER_START,
    payload: data
  }
}
const getSessionByUserIdSuccess = data => {
  return {
    type: GET_SESSION_BY_USER_SUCCESS,
    payload: data
  }
}
const getSessionByUserIdFailure = error => {
  return {
    type: GET_SESSION_BY_USER_FAILURE,
    payload: error
  }
}
export const getSessionByUserId = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(getSessionByUserIdStart(true));
    _getSessionByUserId()
      .then(async (res) => {
        dispatch(getSessionByUserIdSuccess(res));
        resolve(res);
      })
      .catch(async (err) => {
        const parsedError = errorParser.parseError(err)
        dispatch(getSessionByUserIdFailure(parsedError));
        reject(err);
      });
  });
};
/**
 * Search playlist and user
 */
 const searchStart = data => {
  return {
    type: SEARCH_START,
    payload: data
  }
}
const searchSuccess = data => {
  return {
    type: SEARCH_SUCCESS,
    payload: data
  }
}
const searchFailure = error => {
  return {
    type: SEARCH_FAILURE,
    payload: error
  }
}
export const search = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(searchStart(true));
    _search(data)
      .then(async (res) => {
        dispatch(searchSuccess(res));
        resolve(res);
      })
      .catch(async (err) => {
        const parsedError = errorParser.parseError(err)
        dispatch(searchFailure(parsedError));
        reject(err);
      });
  });
};
/**
 * Enrole course
 */
 const enroleCourseStart = data => {
  return {
    type: ENROLE_COURSE_START,
    payload: data
  }
}
const enroleCourseSuccess = data => {
  return {
    type: ENROLE_COURSE_SUCCESS,
    payload: data
  }
}
const enroleCourseFailure = error => {
  return {
    type: ENROLE_COURSE_FAILURE,
    payload: error
  }
}
export const enroleCourse = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(enroleCourseStart(true));
    _enroleCourse(data)
      .then(async (res) => {
        dispatch(enroleCourseSuccess(res));
        resolve(res);
      })
      .catch(async (err) => {
        const parsedError = errorParser.parseError(err)
        dispatch(enroleCourseFailure(parsedError));
        reject(err);
      });
  });
};
/**
 * Get enrole course
 */
 const getEnroleCourseStart = data => {
  return {
    type: GET_ENROLE_COURSE_START,
    payload: data
  }
}
const getEnroleCourseSuccess = data => {
  return {
    type: GET_ENROLE_COURSE_SUCCESS,
    payload: data
  }
}
const getEnroleCourseFailure = error => {
  return {
    type: GET_ENROLE_COURSE_FAILURE,
    payload: error
  }
}
export const getEnroleCourse = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(getEnroleCourseStart(true));
    _getEnroledCourse()
      .then(async (res) => {
        dispatch(getEnroleCourseSuccess(res));
        resolve(res);
      })
      .catch(async (err) => {
        const parsedError = errorParser.parseError(err)
        dispatch(getEnroleCourseFailure(parsedError));
        reject(err);
      });
  });
};